import React from "react";
import QuotationHistoryComponent from "./quotation-history.component";

const QuotationHistoryContainer = () => {
  return <QuotationHistoryComponent />;
};

export default QuotationHistoryContainer;
